import { Action } from 'redux-actions';
import { all, put, select, takeEvery } from 'redux-saga/effects';

import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';

import { getActorSummaryRequest } from '../../api/Actor/getActorSummaryQuery';
import { executeSagaRequest } from '../../services';

import * as actionTypes from './actionTypes';
import { selectGetActorSummaryByIdWasLoaded } from './selectors';

interface GetActorSummaryWorkerPayload {
  actorId?: string;
  actorType?: string;
  sellerId?: string;
  ownerId?: string;
}
function* getActorSummaryWorker({
  payload = {},
}: {
  payload?: GetActorSummaryWorkerPayload;
}): any {
  const { actorId, actorType, sellerId, ownerId } = payload;
  const meta = {
    indexer: actorId,
    actorId,
    actorType,
  };

  if (!actorType) {
    return null;
  }

  const wasLoaded = yield select((state) =>
    selectGetActorSummaryByIdWasLoaded(state, { actorId }),
  );

  if (wasLoaded) {
    return null;
  }

  yield executeSagaRequest(
    actionTypes.GET_ACTOR_SUMMARY_BY_ID,
    getActorSummaryRequest({ actorId, actorType, sellerId, ownerId }),
    meta,
  );

  yield put(actionTypes.GET_ACTOR_SUMMARY_BY_ID.end(meta));

  return true;
}
function* getActorSummaryWatcher() {
  yield takeEvery<Action<GetActorSummaryWorkerPayload>>(
    actionTypes.GET_ACTOR_SUMMARY_BY_ID.BASE,
    getActorSummaryWorker,
  );
}

export default function* mainSaga() {
  try {
    yield all([getActorSummaryWatcher()]);
  } catch (error) {
    logCritical(error);
  }
}
